import React from "react";
import useStyles from "../styles";
import { TextField } from "@material-ui/core";

const InputDisableAge = ({ value, type, label, name, placeholder }) => {
    const classes = useStyles();

    return (
        <div>
            <label className={classes.label} >{label}</label>
            <TextField
                disabled="true"
                InputProps={{
                    classes: {
                        focused: classes.textBorder,
                        input: classes.inputForm,
                    },
                }}
                value={value != "Edad" || value == '' ? value + " años" : value}
                placeholder={placeholder}
                type={type}
                name={name}
                style={{ width: '85%' }}
                inputStyle={{ width: '85%' }}
            />
        </div>
    );
}

export default InputDisableAge;